<div class="an-custom-button">
  <button [type]="type || 'button'" class="an-custom-button__cta" [ngStyle]="buttonStyles" (click)="buttonClick()">
    <span class="an-cta__icon" *ngIf="showIcon">
      <ng-content #icon></ng-content>
    </span>
    <span class="an-cta__label" [ngStyle]="labelStyles"> {{ label }} </span>
  </button>
</div>